// eslint-disable-next-line no-undef
export const stripe = typeof Stripe === 'function' ? Stripe(process.env.REACT_APP_STRIPE_KEY) : null;
export const elements = !!stripe ? stripe.elements() : null;